// Parse Lord Krishna's first-person response.
// Format from system prompt:
//   4–6 short paragraphs separated by blank lines.
//   Exactly ONE paragraph begins with the literal word "Today,".
//   That paragraph is the action step.

export function parseKrishnaAnswer(raw) {
  if (!raw) return { paragraphs: [], action: "", opening: "", closing: "" };

  const text = raw.replace(/\r/g, "").trim();
  // Split by one or more blank lines
  const rawParas = text.split(/\n\s*\n/).map((p) => p.trim()).filter(Boolean);

  const paragraphs = rawParas.map((p) => ({
    text: p,
    isAction: /^today\s*,/i.test(p),
  }));

  const actionPara = paragraphs.find((p) => p.isAction);
  const action = actionPara ? actionPara.text : "";
  const opening = paragraphs[0]?.text || "";
  const closing = paragraphs[paragraphs.length - 1]?.text || "";

  return { paragraphs, action, opening, closing };
}

// The reflection card's takeaway = the "Today," action.
export function reflectionTakeaway(parsed) {
  if (!parsed) return "";
  if (parsed.action) {
    // Trim the leading "Today, " for a cleaner card headline while keeping meaning.
    // Actually we want to keep the "Today," so the user knows it's actionable.
    return parsed.action;
  }
  return parsed.closing || parsed.opening || "";
}
